import { reactive, readonly } from 'vue'

const STORAGE_KEY = 'ewu:show-loading-overlays'

const state = reactive({
  restaurantId: null,
  showLoadingOverlays: false,
})

function normalizeStoredBoolean(value) {
  if (value === null || value === undefined || value === '') return null
  if (value === true || value === 'true' || value === '1') return true
  if (value === false || value === 'false' || value === '0') return false
  return null
}

function readStoredValue() {
  if (typeof window === 'undefined') return null

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return normalizeStoredBoolean(stored)
  } catch (error) {
    console.warn('Unable to read loading overlay preference:', error)
    return null
  }
}

export function setLoadingOverlayPreference(value, restaurantId = null) {
  state.restaurantId = restaurantId || state.restaurantId
  state.showLoadingOverlays = Boolean(value)

  if (typeof window === 'undefined') return state.showLoadingOverlays

  try {
    window.localStorage.setItem(STORAGE_KEY, state.showLoadingOverlays ? 'true' : 'false')
  } catch (error) {
    console.warn('Unable to persist loading overlay preference:', error)
  }

  return state.showLoadingOverlays
}

export function hydrateLoadingOverlayPreference(restaurantId = null) {
  state.restaurantId = restaurantId || state.restaurantId

  const stored = readStoredValue()
  if (stored === null) {
    state.showLoadingOverlays = false
    return state.showLoadingOverlays
  }

  state.showLoadingOverlays = stored
  return state.showLoadingOverlays
}

export const loadingOverlayPreference = readonly(state)

hydrateLoadingOverlayPreference()
